/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';

export interface GetUserInvitation$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
}

export function getUserInvitation(http: HttpClient, rootUrl: string, params: GetUserInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;

/**
 * The invitation URL for the user
 */
'invitationUrl'?: string;

/**
 * Expiration timestamp of the invitation
 */
'expiresAt'?: string;

/**
 * Timestamp when the invitation was sent
 */
'sentAt'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, getUserInvitation.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      
      /**
       * The invitation URL for the user
       */
      'invitationUrl'?: string;
      
      /**
       * Expiration timestamp of the invitation
       */
      'expiresAt'?: string;
      
      /**
       * Timestamp when the invitation was sent
       */
      'sentAt'?: string;
      }>;
    })
  );
}

getUserInvitation.PATH = '/users/{userId}/invitation';
